import { combineReducers } from 'redux-immutablejs';

import abstractSubdivisionsReducer from './abstractSubdivisions';
import appraiserSettingsReducer from './appraiserSettings';
import pricingTableReducer from './pricingTable';
import incomeModelsReducer from './incomeModels';
import marketAreaReducer from './marketArea';
import modelsReducer from './models';
import cacheReducer from './cache';
import exportReducer from './export';
import landModelsReducer from './landModels';
import recalculationReducer from './recalculation';
import RollCorrectionReducer from './rollCorrection';
import depreciationMethodsReducer from './depreciationMethods';
import depreciationCategoriesReducer from './depreciationCategories';
import appraisalNoticeReducer from './notice';
import estimateCalcReducer from './estimateCalc';
import officeInfoReducer from './officeInfo';
import dataEntryReducer from './dataEntry';
import bppRenditionReducer from './bppRendition';
import tirzReducer from './tirz';
import globalReducer from './global';
import microsoftReducer from './microsoft';
import internalAdministrationReducer from './internalAdministration';
import letterCaseSettingReducer from './letterCaseSetting';

export default combineReducers({
  abstractSubdivisions: abstractSubdivisionsReducer,
  appraiserSettings: appraiserSettingsReducer,
  pricingTable: pricingTableReducer,
  incomeModels: incomeModelsReducer,
  marketArea: marketAreaReducer,
  models: modelsReducer,
  cache: cacheReducer,
  export: exportReducer,
  landModels: landModelsReducer,
  recalculation: recalculationReducer,
  rollCorrection: RollCorrectionReducer,
  depreciationMethods: depreciationMethodsReducer,
  depreciationCategories: depreciationCategoriesReducer,
  appraisalNotice: appraisalNoticeReducer,
  estimateCalc: estimateCalcReducer,
  global: globalReducer,
  officeInfo: officeInfoReducer,
  dataEntry: dataEntryReducer,
  bppRendition: bppRenditionReducer,
  tirz: tirzReducer,
  microsoft: microsoftReducer,
  internalAdministration: internalAdministrationReducer,
  letterCaseSetting: letterCaseSettingReducer,
});
